import { Helmet } from 'react-helmet';
import dayjs, { Dayjs } from 'dayjs';
import { Box, Container, Grid, Typography } from '@mui/material';

import useSettings from '../../hooks/useSettings';
import { SplitTest } from '../../components/dashboard/marketing/splitTestConfiguration';

export type DiscountType = 'numberOfDays' | 'percentage' | 'fixedAmount';

const SplitTestConfig = () => {
  const { settings } = useSettings();

  return (
    <>
      <Helmet>
        <title>Dashboard: Split Test Config | Sens.ai</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 8
        }}
      >
        <Container maxWidth={settings.compact ? 'xl' : false}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SplitTest />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default SplitTestConfig;
